import { http, sdkAnalytics } from '@itau-loans-www/services'
import { goTo, getProduct, isClient, storage } from '@itau-loans-www/utils'

export const defaultCallback = ({ proposal, setButtonLoading, setProduct }) => {
  const { logo, productCode, simulationOptionUuid } = proposal

  storage.session.setItem(
    'simulationOptionUuid',
    JSON.stringify(simulationOptionUuid)
  )

  const requestBody = {
    simulation_option_uuid: simulationOptionUuid,
    product_code: productCode
  }

  setButtonLoading(true)

  const productFlow = getProduct()

  if (productFlow === 'consignado') {
    sdkAnalytics.track('trackClickOfferConsig', `btn:${productCode}`)
  }

  http.proposal
    .putSimulationSummary(requestBody)
    .then(({ final_screen, link, next_step }) => {
      setProduct({ proposal, logo, link })

      if (link && productCode === 'FGTS') {
        isClient() && window.location.assign(link)
        return
      }

      if (!final_screen) {
        goTo(next_step)
        return
      }

      goTo(final_screen)
    })
    .catch(() => setButtonLoading(false))
}

export const finishProposalCallback = ({
  proposal,
  setButtonLoading,
  setProduct
}) => {
  const { logo, productCode, simulationOptionUuid } = proposal

  storage.session.setItem(
    'simulationOptionUuid',
    JSON.stringify(simulationOptionUuid)
  )

  const requestBody = {
    simulation_option_uuid: simulationOptionUuid,
    product_code: productCode
  }

  const requestPostBody = {
    simulation_option_uuid: simulationOptionUuid,
    contact_type: 'whatsapp'
  }

  const productFlow = getProduct()

  if (productFlow === 'consignado') {
    sdkAnalytics.track('trackClickOfferConsig', `btn:${productCode}`)
  }

  setButtonLoading(true)
  http.proposal
    .putSimulationSummary(requestBody)
    .then(({ link, final_screen }) => {
      setProduct({ proposal, logo, link })

      http.proposal
        .finishSimulation(productCode, requestPostBody)
        .then((response) => {
          if (response?.link) {
            isClient() && window.open(response?.link, '_blank')
          }

          goTo(final_screen)
        })
        .catch(() => setButtonLoading(false))
    })
    .catch(() => setButtonLoading(false))
}

export const fgtsWebAppCallback = ({
  proposal,
  setButtonLoading,
  setProduct
}) => {
  setButtonLoading(true)

  const { productCode, simulationOptionUuid } = proposal

  setButtonLoading(true)

  sdkAnalytics.track('trackClick', 'btn:finalizar-no-app-itau')

  storage.session.setItem(
    'simulationOptionUuid',
    JSON.stringify(simulationOptionUuid)
  )

  http.proposal
    .finishFGTSProposal('whatsapp', '', productCode)
    .then(({ final_screen, link, qr_code }) => {
      setProduct({ proposal: { ...proposal, link: link, qrcode: qr_code } })

      if (link && !qr_code) {
        isClient() && BUILD_ENV !== 'e2e' && window.open(link, '_blank')
      }

      if (final_screen) {
        goTo(final_screen)
      }
    })
    .catch(() => setButtonLoading(false))
}

export const fgtsCallback = ({ proposal, setButtonLoading, setProduct }) => {
  setButtonLoading(true)

  const { productCode, simulationOptionUuid } = proposal

  storage.session.setItem(
    'simulationOptionUuid',
    JSON.stringify(simulationOptionUuid)
  )

  const productFlow = getProduct()

  if (productFlow !== 'fgts') {
    defaultCallback({ proposal, setButtonLoading, setProduct })
    return
  }

  http.proposal
    .finishFGTSProposal('whatsapp', '', productCode)
    .then(({ next_step }) => {
      setProduct({ proposal: proposal })
      if (next_step) {
        goTo(next_step)
      } else {
        goTo('final-screen-fgts-success')
      }
    })
    .catch(() => setButtonLoading(false))
}
